module.exports = __webpack_public_path__ + "img/woka_act_more.d4aa44d5.png";